import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { Topbar } from '../components/Topbar';
import { ThemeToggle } from '../components/ThemeToggle';
import { Icon } from '../components/Icons';
import { btnIcon } from '../components/buttons';
import { useAuthStore } from '../auth/store';

function screenMeta(path: string): { eyebrow: string; title: string } {
  const eyebrow = 'Snapmon · Insights';
  if (path === '/') return { eyebrow, title: 'Overview' };
  if (path.startsWith('/users/')) return { eyebrow, title: 'User detail' };
  if (path.startsWith('/users')) return { eyebrow, title: 'Users' };
  if (path.startsWith('/collections')) return { eyebrow, title: 'Collections' };
  if (path.startsWith('/growth')) return { eyebrow, title: 'Growth' };
  if (path.startsWith('/price-alerts')) return { eyebrow, title: 'Price Alerts' };
  if (path.startsWith('/subscriptions')) return { eyebrow, title: 'Subscriptions & Revenue' };
  if (path.startsWith('/scan-sessions')) return { eyebrow, title: 'Scan Sessions' };
  if (path.startsWith('/scanner')) return { eyebrow, title: 'Scanner Health' };
  if (path.startsWith('/pricing')) return { eyebrow, title: 'Pricing Engine Health' };
  return { eyebrow, title: 'Insights' };
}

export function ShellLayout() {
  const location = useLocation();
  const admin = useAuthStore((s) => s.admin);
  const meta = screenMeta(location.pathname);

  return (
    <div className="app">
      <Sidebar />
      <main style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Topbar
          eyebrow={meta.eyebrow}
          title={meta.title}
          right={
            <>
              <ThemeToggle />
              <button style={{ ...btnIcon, width: 36, height: 36 }} title="Notifications">
                <Icon.Bell />
              </button>
              {admin && (
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: 'var(--brand)',
                    color: 'var(--bg-elev)',
                    display: 'grid',
                    placeItems: 'center',
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: 13,
                    textTransform: 'uppercase',
                  }}
                >
                  {admin.username.slice(0, 2)}
                </div>
              )}
            </>
          }
        />
        <Outlet />
      </main>
    </div>
  );
}
